<template>
    <v-card class="overflow-hidden v-card v-sheet theme--light px-1 py-3 m-0">
    <!-- Alert message -->
    <div>
      <v-alert :type="alert_type" :model-value="alert" :value="alert" transition="scale-transition">{{ alert_message }}</v-alert>
    </div>
    <!-- Header component -->
    <div> <HeaderComponent :headerTitle="headerText" :assignBuyer="assignBuyer" :lotIdB2b="lotIdB2b"/></div>
    <!-- Tabs -->
    <!-- assign confirm popup -->
    <v-row justify="center">
      <v-dialog v-model="successpopup" persistent max-width="424px">
        <v-card class="v-card-100">
            <v-card-title class="d-flex align-center">
              <v-spacer></v-spacer>
              <v-btn icon variant="text" @click="successpopup = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-card-title>
            <v-card-text class="text-center">
              <span> Are you sure you want to assign Lot "{{this.lotIdB2b}}" to {{biddername}}?</span>
            </v-card-text>
            <v-card-actions style="justify-content: center;">
              <v-btn  size='small' variant='text' color="normal" class="border-color text-none" @click="successpopup = false">Cancel</v-btn>
              <v-btn size='small' variant='flat' :color="number > 0 ? '' : 'primary'" class="text-none" @click="confirmButton" :disabled="number > 0">Confirm</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
     <v-row justify="center" ref="createForm">
      <v-dialog v-model="remarksBuyerPopup" persistent max-width="780px">
        <v-card class="v-card-100">
          <v-card class="v-card-100">
            <v-card-title>
            <v-row class="ma-1">
              <span>{{(select_value === 'confirm_buyer' || select_value === 'approvefrom_pending') ? 'Remarks' : 'Reason'}}</span>
              <v-spacer></v-spacer>
                <v-icon @click="remarksBuyerPopup = false">mdi-close</v-icon>
             </v-row>   
            </v-card-title>
          </v-card>
          <v-card-text>
            <v-container>
              <v-row>
                <v-text-field v-model="remarks_confirm_buyer" class="m-3" label="Remarks" variant="outlined">                
                </v-text-field>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions style="justify-content: center;">
            <v-btn 
              @click="remarksBuyerPopup = false"
              variant="outlined"
              color="indigo"
              class="text-none"
              >Cancel</v-btn>
            <v-btn 
              color="primary"
              class="text-none"
              :disabled="number > 0"
              @click="assignBuyerFunc"
              variant="flat"
             >Submit</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <v-card class="v-card-100 m-0 text-left mt-9">
      <v-tabs color="primary">
        <v-tab ripple style="text-transform:none!important;" @click="loadData(tab, 'tab_clicked')"
          v-for="(tab, index) in tabs" :key="index" class="tab-color">{{tab}}</v-tab>
      </v-tabs>
    </v-card>
    <v-card-title style="padding: 28px;">
        <!-- Search fields -->
        <v-row>
        <v-col cols="8" sm="8">
          <v-text-field prepend-inner-icon="mdi-magnify" color="primary" hide-details  v-model="buyer_id_search" label="Search" style="max-width: 300px;" variant="outlined" v-on:keyup.enter="loadData(active_tab)"></v-text-field>
        </v-col>
        <v-col cols="4" sm="4">

        <!-- Actions buttons -->
        <v-card-actions class="d-flex justify-end">
          <v-btn class="ma-2 text-none" variant="flat" :color="this.selected.length == 0 ? '' : 'primary'" :disabled="selected.length !== 1" @click="reason_assign === null ? openRemaksPopup() : assignBuyerFunc()">Assign</v-btn> 
        </v-card-actions>
        </v-col>
      </v-row>
    <!-- Filter -->
    <!-- <v-expansion-panels class="custom-control_outlined filter-panels-btn" ref = "filterPopupRef" readonly style="max-width: 300px; margin-bottom: 28px; min-height: 56px;">
        <v-expansion-panel outlined @click="filterListOfButtons" >
          <v-expansion-panel-title>Filter
          </v-expansion-panel-title>
        </v-expansion-panel>
      </v-expansion-panels> -->
    </v-card-title>
    <v-layout column>
      <v-col cols="12" style="overflow: auto">
        <v-data-table hover 
          density="compact" 
          :search="search" 
          show-select
          v-model="selected"
          disable-pagination
          :hide-default-footer="true"
          :headers="headers"
          :items="table_data"
          :loading="loading"
          loading-text="Loading Data... Please wait"
          class="elevation-1"
          return-object
          :items-per-page="pageSize"
          >
          <!-- <template v-slot:item="{ item }">
            <tr @click="selectRow(item)" :class="{ 'active': isActiveRow(item), 'text-left': true }">
              <td>{{ item.higest_bid_id }}</td>
              <td>{{ item.user_name }}</td>
              <td>{{ item.organization ? item.organization : "-" }}</td>
              <td>{{ item.higest_bid }}</td> -->
              <!-- Add other table columns here -->
            <!-- </tr>
          </template> -->
         <template #bottom></template>
        </v-data-table>
      </v-col>
    </v-layout>
  <div>
      <v-row class="ml-2 pb-4">
          <span class="PaddingItemPerPage d-flex mt-4">
              <label class="" style="margin-top: -2px;">Rows Per Page</label>
              <v-select v-model="pageSize" :items="pageSizes" class="custom-pagination-ui" @update:modelValue="handlePageSizeChange"
              variant="outlined" density="compact" style="margin-left: 120px;margin-top:-10px;position:absolute;"></v-select>
          </span>
          <span class="item-selected" :style="this.totalCount > 9999 ? 'left:24% !important;' : ''"> <span v-if="selected.length == 1">{{ selected.length }} Item Selected</span> <span
              v-if="selected.length > 1">{{ selected.length }} Items Selected</span> </span>
          <v-spacer></v-spacer>
          <div class="d-flex">
              <span :class="this.totalCount > 9999 ? 'pt-2 mt-3 mr-1' : 'pt-2 mt-3 mr-1'" v-if="this.totalCount > 0">Showing Results {{ (this.page - 1) * this.pageSize + 1 }}
              - {{ Math.min(this.page * this.pageSize, this.totalCount) }} of {{ this.totalCount }}</span>
              <span class="PaddingItemPerPage mr-3" :style="totalPages>7 ? 'min-width: 380px' : 'auto'">
              <v-pagination v-model="page" :length="totalPages" total-visible="7" class="custom-pagination-ui"
              @update:modelValue="handlePageChange" density="compact" rounded="circle"></v-pagination>
              </span>
          </div>
      </v-row>
    </div>
    </v-card>
</template>
<script>
  import HeaderComponent from "../../../../commoncomponents/HeaderComponent.vue";

export default {
    data(){
        return {
           headerText: "Liquidation",
           assignBuyer: true, 
           number: 0,
           infoDataType:"",
           isShow:true,
           selected:[],    
           file: "",
           binaryData:"",
           alert_type:"",
           alert_message:"",
           menu: false,
           loading: false,
           attachment: "",
           alert: false,
              tabs: [
            "Assign"
            ],
          active_tab: "Assign",
          headers: [
          { title: "Buyer ID", key: "higest_bid_id"},
          { title: "Buyer Name", key: "user_name"},
          { title: "Organisation", key: "organization"},
          { title: "Highest Bid", key: "higest_bid"}
        ],
        table_data: [],
        buyer_id_search:'',
        lotIdB2b:'',
        page: 1,
        totalPages: 1,
        pageSize: 25,
        pageSizes: [25, 50, 75, 100],
        successpopup:false,
        biddername:'',
        highestBidId:'',
        usermail:'', 
        highestbid:'',
        number:0,
        remarksBuyerPopup:false,
        remarks_confirm_buyer:'',
        reason_assign:''         
      };
    },
    components: {
      HeaderComponent
    },
    watch: {
      selected(newVal) {
        if(newVal.length > 0){
          if(newVal[0].user_name == this.$store.state.buyer_name){
          this.$toast.warning("You cannot assign the lot to same buyer");
           this.$nextTick(() => {
            this.selected.splice(0);
          });
        }
        }
       
      }
    },
    async created() {
      const lotIdB2b = this.$store.state.lotIds;
      this.reason_assign = this.$store.state.action;
      this.remarks_confirm_buyer = this.$store.state.inventoryId;
      this.lotIdB2b = parseInt(lotIdB2b.substring(1, lotIdB2b.length - 1));
      this.loadData('Assign')    
  },
    methods:{        
        loadData(tab, tab_action) {
      if(tab_action){
        this.buyer_id_search = ''
      }
      this.loading = true;
      this.selected = [];
      this.active_tab = tab;
      this.table_data = [];
      this.page = 1;
      this.totalPages = 1;
      this.pageSize = 25;
      if (tab == "Assign") {
        this.headers = [
        { title: "Buyer ID", key: "higest_bid_id"},
          { title: "Buyer Name", key: "user_name"},
          { title: "Organisation", key: "organization"},
          { title: "Highest Bid", key: "higest_bid"}
        ];
        this.fetchBuyerList();
      }
    },
      fetchBuyerList() {
        let lotIds = JSON.parse(this.$store.state.lotIds)
         const params = {
          search_text: this.buyer_id_search, 
        };
      this.$httpSecured
        .get(`/api/v2/warehouse/liquidation_order/pending/decision/get_bidders?id=${lotIds}`,  {params} )
        .then(response => {
          if (response.data) {
            this.table_data = response.data.bids_details
            this.table_data.forEach((item, index) => {
              item.id=index+1
            });
            this.loading = false;
          } else {
            this.loading = false;
            this.showAlert("error", "No Data Found");
          }
        })
        .catch(error => {
          this.showAlert("error", error.response.data.error);
          this.loading = false;
        });
      },
      showAlert(alert_type, alert_message) {
      this.alert = true;
      this.alert_type = alert_type;
      this.alert_message = alert_message;
      this.alertTimeOut();
    },
    alertTimeOut() {
      setTimeout(() => {
        this.alert = false;
      }, 3000);
    },
    getRequestParams(page, pageSize) {
      let params = {};

      if (page) {
        params["page"] = page;
      }
      if (pageSize) {
        params["size"] = pageSize;
      }
      return params;
    },
    handlePageChange(value) {
      this.page = value;
      this.fetchBuyerList();
    },
    handlePageSizeChange(size) {
      this.pageSize = size;
      this.page = 1;   
      this.fetchBuyerList();   
    },
    assignBuyerFunc(){
       this.remarksBuyerPopup = false;
       this.successpopup = true; 
    },
    confirmButton(){
      this.number++;
      let lotIds = JSON.parse(this.$store.state.lotIds);
      const request_type_update = this.$store.state.navigate_tab.navigate_tab === 'Pending Decision' ? "buyer_lot_assign_below_reserve_price" : "buyer_lot_assigned_other_than_highest_bidder"
      this.$httpSecured
        .put(`/api/v2/warehouse/liquidation_order/pending/decision/${lotIds}`, {
          vendor_code: this.selected[0].higest_bid_id,
          user_name: this.selected[0].user_name,
          user_email: this.selected[0].user_name,
          higest_bid: this.selected[0].higest_bid,
          reason:this.reason_assign,
          remarks:this.remarks_confirm_buyer,
          request_type:request_type_update
        })
        .then(response => {
          if (response.status === 200) {
            this.successpopup = false;
            this.$store.commit("setLotIds", { lotIds: JSON.stringify([]) });
            this.$store.commit("setMessage", {
              responseMessage: response.data.message,
              action: this.$store.state.navigate_tab.navigate_tab === 'Pending Decision' ? "re_publish_return" : "re_publish_return_payment"
            });
            this.$router.push({ name: "liquidationNew" });
          } else {
            this.number = 0;
            this.showAlert("error", "Something went Wrong !!");
          }
        })
        .catch(error => {
          this.showAlert("error", error.response.data.error);
          this.number = 0;
        });
    },
    selectRow(item) {
      this.biddername = item.user_name;
      this.highestBidId = item.higest_bid_id;
      this.usermail = item.user_email;
      this.highestbid = item.higest_bid;
      const index = this.selected.findIndex(
        selectedItem => selectedItem === item
      );
      if (index !== -1) {
        this.selected.splice(index, 1);
      } else {
        this.selected.push(item);
      }
    },
    isActiveRow(item) {
      return this.selected.includes(item);
    },
    openRemaksPopup(){
      this.remarksBuyerPopup = true;
    }
  }
};
</script>
<style scoped>
.border-color{
  border: 1px solid #0357d0;
}
</style>
